import * as fromAPIs from '~/store/reducers/apis';

export const getAPIsIsFetched = (state) => fromAPIs.getIsFetched(state);
export const getAPIById = (state, id) => fromAPIs.getAPIById(state, id);
export const getAPIIds = (state) => fromAPIs.getAPIIds(state);
export const getAPIs = (state) => fromAPIs.getAPIs(state);
